export default __webpack_public_path__ + "static/media/nfo-banner-healthcare-comp-mobile.91b40af1.jpg";